import { Header, NetworkProtectionTabs } from './components';
import { activeTab, queryParamsInitial, setSearchParamsToState } from './store';
import { MonitoringObjectsView, ProtectedProfilesView } from './views';
import { GET_NETWORK_PROTECTION_SETTINGS } from '@/common/actions/get';
import { getFiltersFromSearchParams } from '@/utils';
import { useLazyQuery } from '@apollo/client';
import { Box } from '@servicepipe/ui-components';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const NetworkProtectionV2 = () => {
  const { id: partnerClientAccountId } = useParams();
  const [networkProtectionData, setNetworkProtectionData] = useState(null);
  const [searchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({
    ...queryParamsInitial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  const [getNetworkProtectionSettingApi] = useLazyQuery(GET_NETWORK_PROTECTION_SETTINGS, {
    variables: {
      id: Number(partnerClientAccountId),
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    getNetworkProtectionSettingApi().then(({ data }) => {
      if (!data?.accountSettings) {
        return;
      }

      setNetworkProtectionData({
        ...data.accountSettings.networkProtection,
        id: data.accountSettings.id,
      });
    });
  }, []);

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
  }, [searchParams]);

  return (
    <Box width="100%" minWidth="0" direction="column" padding="35px 0" gap="35px">
      {partnerClientAccountId && networkProtectionData && <Header data={networkProtectionData} />}

      <Box display="flex" direction="column" width="100%" minWidth="0">
        <NetworkProtectionTabs queryParams={queryParams} />

        <MonitoringObjectsView isShowTable={queryParams.tab === activeTab.monitoringObjects} />

        <ProtectedProfilesView isShowTable={queryParams.tab === activeTab.protectedProfiles} />
      </Box>
    </Box>
  );
};

export default NetworkProtectionV2;
